import {Button} from "../Button/Button";
export function Mp3Player({mp3, mp3Open, mp3SetOpen, title}) {
  return (
    <div hidden className=" flex justify-center">
      <div
        className={`${
          mp3Open ? "" : "opacity-0 -z-50"
        } ease-in-out transition-opacity duration-200 z-50 fixed bottom-0 sm:bottom-4 flex items-center  w-[99vw] sm:w-[66vw] bg-green text-black text-sm font-bold px-4 py-3`}
        role="alert">
        <audio controls volume="1" src={mp3} className="w-[60em] sm:w-[25em]"></audio>
        <p className="truncate ... text-lg whitespace-nowrap overflow-ellipsis capitalize px-3">
          {title ? title : "unnamed file "}
        </p>
        <div className="flex flex-auto justify-end text-lg">
          <Button
            className="bg-black text-green font-bold px-4 py-3 rounded-sm text-sm"
            onClick={() => {
              mp3SetOpen(false);
            }}>
            Close
          </Button>
        </div>
      </div>
    </div>
  );
}
